<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {}
    },
    mounted() {
      var flagRouter = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      if (!flagRouter) {
        this.$router.replace('/' + this.$store.state.activeIndex);
      } else {
        var width = $('body').width() // 通过window.screen.width获取屏幕的宽度
        var offWidth = width / 7.5 // 这里用宽度/30表示1rem取得的px
        document.getElementsByTagName('html')[0].style.fontSize = offWidth + 'px' // 把rem的值复制给顶级标签html的font-size

        this.$router.replace('/' + this.$store.state.activeIndexM);

        window.onload = function() {
          document.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
              event.preventDefault()
            }
          })
          document.addEventListener('gesturestart', function (event) {
            event.preventDefault()
          })
          var lastTouchEnd=0;
          document.addEventListener('touchend',function (event) {
            var now=(new Date()).getTime();
            if(now-lastTouchEnd<=300){
              event.preventDefault();
            }
            lastTouchEnd=now;
          },false);
        }
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;
    color: #2c3e50;
    position: relative;
  }
  body,p {
    margin: 0;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  iframe[src*="ucweb.com"] { display: none !important; }
  iframe[id^="head__"] { display: none !important; }
  iframe[id^="utp__"] { display: none !important; }
</style>



// WEBPACK FOOTER //
// src/App.vue